<h1 style="position: relative; bottom: 10px; text-align: center; ">Manage Notifications</h1>
<!-- Admin View -->
<div style="height: 29em;" [ngStyle]="{'display': isAdmin ? '' : 'none' }">
    <mat-tab-group (selectedIndexChange)="onAdminTabChange($event)">
        <!-- Admin's Personal Schedule Tab -->
        <mat-tab label="Personal Schedule">
            <ng-container *ngTemplateOutlet="scheduleTab; context: { idSuffix: 'personal' }"></ng-container>
        </mat-tab>
        <!-- Admin Tab To Schedule Other Users -->
        <mat-tab label="Manage Other Users">
            <div class="tab-body">
            <!-- Recipient Block Admin Client View -->
            <div class="form-block" [ngStyle]="{'display': isAdminManagingUser ? 'none' : '' }">
                <span style="font-size: large; font-weight: 400;">Select A User To Manage</span>
                <span *ngIf="isUserNXTsoft === false" [ngStyle]="{'display': pleaseWait ? '' : 'none' }" class="scheduled-badge">Retrieving users, please wait.</span>
                <div 
                    *ngIf="isUserNXTsoft === false" 
                    [ngStyle]="{'display': pleaseWait ? 'none' : '' }"
                    class="table-container user-list-scroll" 
                >
                    <table
                        class="table"
                        mat-table
                        #table
                        [dataSource]="dataSource"
                        style="width: 100%"
                        CCMCPerfectScrollbar
                        matSort
                    >
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef class="check-column"></th>
                            <td mat-cell *matCellDef="let element" class="check-column">
                                <span class="row-check-icon" *ngIf="savedRows.has(element)">&#10003;</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>email</th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                style="padding-right: 45px"
                                class="noselect"
                            >
                                {{ element.username }}
                            </td>
                        </ng-container>
                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns; sticky: true"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                            [class.row-selected]="selectedRows.has(row)"
                            (dblclick)="manageUser(row)"
                        ></tr>
                    </table>
                </div>
            </div>

            <!-- View After Admin Selected User -->
            <div [ngStyle]="{'display': isAdminManagingUser ? '' : 'none' }">
                <!-- Schedule Block -->
                <div class="form-block" style="margin-bottom: 2em;">
                    <span style="font-size: large; font-weight: 400;">Schedule</span>
                    <mat-form-field appearance="outline">
                        <mat-label>Frequency</mat-label>
                        <mat-select id="Frequency_managed" [(value)]="managedSubscription.timeInterval" (selectionChange)="managedMarkDirty()">
                            <mat-option value="instantly">Instantly After Each Loan</mat-option>
                            <mat-option value="daily">Daily</mat-option>
                            <mat-option value="weekly">Weekly</mat-option>
                            <mat-option value="bi-weekly">Bi-Weekly</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="managedSubscription.timeInterval !== 'instantly' && managedSubscription.timeInterval !== 'daily'" appearance="outline">
                        <mat-label>Weekday</mat-label>
                        <mat-select id="Weekday_managed" [(value)]="managedSubscription.weekDay" (selectionChange)="managedMarkDirty()">
                            <mat-option value="sunday">Sunday</mat-option>
                            <mat-option value="monday">Monday</mat-option>
                            <mat-option value="tuesday">Tuesday</mat-option>
                            <mat-option value="wednesday">Wednesday</mat-option>
                            <mat-option value="thursday">Thursday</mat-option>
                            <mat-option value="friday">Friday</mat-option>
                            <mat-option value="saturday">Saturday</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- Time Zone shows for every cadence; only Time is hidden for instant sends. -->
                    <div class="schedule-time-row">
                        <div class="time-field-wrapper" *ngIf="managedSubscription.timeInterval !== 'instantly'">
                            <label class="time-field-label" for="NotificationTime_managed">Time</label>
                            <input
                                type="time"
                                name="NotificationTime_managed"
                                id="NotificationTime_managed"
                                aria-label="Notification time"
                                class="time-field-input"
                                style="height: 3.6em;"
                                [(ngModel)]="managedSubscription.time"
                                (ngModelChange)="managedMarkDirty()"
                            >
                        </div>
                        <mat-form-field appearance="outline" style="width: 26em;">
                            <mat-label>Time Zone</mat-label>
                            <mat-select
                                id="TimeZone_managed"
                                [value]="getTimeZoneSelection(managedSubscription)"
                                (selectionChange)="onTimeZoneSelected(managedSubscription, $event.value); managedMarkDirty()"
                                aria-label="Notification time zone"
                            >
                                <mat-option *ngFor="let timeZone of timeZones" [value]="timeZone.value">
                                    {{ timeZone.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Recipient Block -->
                <div class="form-block">
                    <span style="font-size: large; font-weight: 400;">Recipient</span>

                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput [ngModel]="managedPrimaryEmail" readonly type="email">
                    </mat-form-field>
                </div>
            </div>
            </div>
        </mat-tab>
        <!-- Delivery History For The Signed-In User's Subscriptions -->
        <mat-tab label="Delivery Logs">
            <ng-container *ngTemplateOutlet="deliveryLogsTab"></ng-container>
        </mat-tab>
    </mat-tab-group>
</div>

<!-- Non-Admin View -->
<div style="height: 29em;" [ngStyle]="{'display': isAdmin ? 'none' : '' }">
    <mat-tab-group (selectedIndexChange)="onStandardTabChange($event)">
    <mat-tab label="Schedule">
        <ng-container *ngTemplateOutlet="scheduleTab; context: { idSuffix: 'nonAdmin' }"></ng-container>
    </mat-tab>
    <!-- Delivery History For The Signed-In User's Subscriptions -->
    <mat-tab label="Delivery Logs">
        <ng-container *ngTemplateOutlet="deliveryLogsTab"></ng-container>
    </mat-tab>
    </mat-tab-group>
</div>

<!--
    Schedule Tab Content, Shared By Both Layouts.
    Both layouts are in the DOM at once, so element ids are suffixed per layout
    to keep them unique.
-->
<ng-template #scheduleTab let-idSuffix="idSuffix">
    <div class="tab-body">
        <!-- Read-Only Summary Of The Current Schedule -->
        <div class="schedule-summary" *ngIf="!isEditingSchedule">
            <div class="summary-header">
                <span class="summary-product">{{ productLabel }}</span>
                <span
                    class="summary-badge"
                    *ngIf="isScheduleBadgeVisible"
                    [ngClass]="subscription.timeInterval === 'instantly' ? 'instant' : 'scheduled'"
                >
                    {{ subscription.timeInterval === 'instantly' ? 'Instant' : 'Scheduled' }}
                </span>

                <!-- Opt-in Toggle -->
                <mat-slide-toggle
                    class="summary-toggle"
                    [checked]="subscriptionFlag"
                    (change)="onClickSwitch($event)"
                    [matTooltip]="subscriptionFlag ? 'Opt out of notifications' : 'Opt in to notifications'"
                    aria-label="Opt in to notifications"
                ></mat-slide-toggle>
            </div>

            <div class="summary-details">
                <div class="detail-row">
                    <span class="detail-label">Schedule</span>
                    <span>{{ getScheduleSummary(subscription) }}</span>
                </div>
                <div class="detail-row" *ngIf="getTimeZoneLabel(subscription) as timeZoneLabel">
                    <span class="detail-label">Time zone</span>
                    <span>{{ timeZoneLabel }}</span>
                </div>
                <div class="detail-row" *ngIf="getNextRunDisplay(subscription) as nextRun">
                    <span class="detail-label">Next run</span>
                    <span class="next-run">{{ nextRun }}</span>
                </div>
                <div class="detail-row" *ngIf="getReportWindowLabel(subscription) as reportWindow">
                    <span class="detail-label">Data window</span>
                    <span>{{ reportWindow }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">Filter</span>
                    <span>{{ subscription.filter }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">Recipients</span>
                    <span>{{ primaryEmail }}</span>
                </div>
            </div>

            <div class="summary-actions">
                <button
                    mat-icon-button
                    [id]="'edit-schedule-' + idSuffix"
                    (click)="startScheduleEdit()"
                    matTooltip="Edit schedule"
                    aria-label="Edit schedule"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>

        <!-- Schedule Form, Opened From The Summary's Edit Button -->
        <ng-container *ngIf="isEditingSchedule">
            <!-- Schedule Block -->
            <div class="form-block" style="margin-bottom: 2em;">
                <span style="font-size: large; font-weight: 400;">Schedule</span>
                <mat-form-field appearance="outline">
                    <mat-label>Frequency</mat-label>
                    <mat-select [id]="'Frequency_' + idSuffix" [(value)]="subscription.timeInterval" (selectionChange)="markDirty()">
                        <mat-option value="instantly">Instantly After Each Loan</mat-option>
                        <mat-option value="daily">Daily</mat-option>
                        <mat-option value="weekly">Weekly</mat-option>
                        <mat-option value="bi-weekly">Bi-Weekly</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="subscription.timeInterval !== 'instantly' && subscription.timeInterval !== 'daily'" appearance="outline">
                    <mat-label>Weekday</mat-label>
                    <mat-select [id]="'Weekday_' + idSuffix" [(value)]="subscription.weekDay" (selectionChange)="markDirty()">
                        <mat-option value="sunday">Sunday</mat-option>
                        <mat-option value="monday">Monday</mat-option>
                        <mat-option value="tuesday">Tuesday</mat-option>
                        <mat-option value="wednesday">Wednesday</mat-option>
                        <mat-option value="thursday">Thursday</mat-option>
                        <mat-option value="friday">Friday</mat-option>
                        <mat-option value="saturday">Saturday</mat-option>
                    </mat-select>
                </mat-form-field>
                <!--
                    Time Zone applies to every cadence, including instant sends,
                    so only the Time field is hidden when there is no send time
                    to pick.
                -->
                <div class="schedule-time-row">
                    <div class="time-field-wrapper" *ngIf="subscription.timeInterval !== 'instantly'">
                        <label class="time-field-label" [attr.for]="'NotificationTime_' + idSuffix">Time</label>
                        <input
                            type="time"
                            [attr.name]="'NotificationTime_' + idSuffix"
                            [id]="'NotificationTime_' + idSuffix"
                            aria-label="Notification time"
                            class="time-field-input"
                            style="height: 3.6em;"
                            [(ngModel)]="subscription.time"
                            (ngModelChange)="markDirty()"
                        >
                    </div>
                    <mat-form-field appearance="outline" style="width: 26em;">
                        <mat-label>Time Zone</mat-label>
                        <mat-select
                            [id]="'TimeZone_' + idSuffix"
                            [value]="getTimeZoneSelection(subscription)"
                            (selectionChange)="onTimeZoneSelected(subscription, $event.value); markDirty()"
                            aria-label="Notification time zone"
                        >
                            <mat-option *ngFor="let timeZone of timeZones" [value]="timeZone.value">
                                {{ timeZone.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Leaving this code block for when we want to provide users the ability to filter for logs other than failures -->
            <!-- Filter Block -->
            <!-- <div class="form-block" style="margin-bottom: 2em;">
                <span style="font-size: large; font-weight: 400;">Filter</span>
                <mat-form-field appearance="outline">
                    <mat-label>Log Filter</mat-label>
                    <mat-select [id]="'Filter_' + idSuffix" [(value)]="subscription.filter">
                        <mat-option value="success">Success</mat-option>
                        <mat-option value="failure">Failure</mat-option>
                        <mat-option value="all">All</mat-option>
                    </mat-select>
                </mat-form-field>
            </div> -->

            <!-- Recipient Block -->
            <div class="form-block">
                <span style="font-size: large; font-weight: 400;">Recipient</span>

                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput [ngModel]="primaryEmail" readonly type="email">
                </mat-form-field>
            </div>
        </ng-container>
    </div>
</ng-template>

<!-- Delivery Logs Tab Content, Shared By Both Layouts -->
<ng-template #deliveryLogsTab>
    <div class="form-block delivery-logs-tab">
        <!-- Scrolling region: only the log list moves -->
        <div class="delivery-logs-body">
            <div *ngIf="isLoadingLogs" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Loading delivery logs...</p>
            </div>

            <div *ngIf="!isLoadingLogs && deliveryLogs.length === 0" class="empty-state">
                <mat-icon>receipt_long</mat-icon>
                <p>No delivery logs yet</p>
                <p class="hint-text">Logs appear after a notification is sent.</p>
            </div>

            <div *ngIf="!isLoadingLogs && deliveryLogs.length > 0" class="logs-list">
                <div *ngFor="let log of deliveryLogs" class="log-entry">
                    <div class="log-header">
                        <span class="log-status" [ngClass]="getStatusClass(log.status)">{{ log.status }}</span>
                        <span class="log-timestamp">{{ log.timestamp | date:'medium' }}</span>
                    </div>
                    <div class="log-details">
                        <span class="log-detail">Report: {{ log.reportType }}</span>
                        <span class="log-detail">Recipients: {{ log.recipientCount }}</span>
                    </div>
                    <div *ngIf="log.failureReason" class="log-failure">{{ log.failureReason }}</div>
                    <div class="log-correlation">Correlation: {{ log.correlationId }}</div>
                </div>
            </div>
        </div>

        <!-- Pinned footer: stays visible while the list scrolls -->
        <div class="refresh-logs">
            <span *ngIf="autoRefreshActive" class="auto-refresh-hint">Checking for new logs...</span>
            <button
                mat-icon-button
                [disabled]="isLoadingLogs"
                (click)="loadLogs()"
                matTooltip="Refresh delivery logs"
                aria-label="Refresh delivery logs"
            >
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<!-- Footer -->
<div class="bottom-button-container" id="bottom-button-container">
    <!-- Cancel Button -->
    <button class="cancel-button" mat-stroked-button (click)="close()" id="cancel-button" style="height: 40px;">Close</button>

    <!-- Save Button -->
    <button 
        class="save-button" 
        mat-raised-button color="primary" 
        (click)="save()" 
        [disabled]="!formDirty" 
        style="height: 40px;"
        [ngStyle]="{'display': (activeTab === 'schedule' && isEditingSchedule) ? '' : 'none' }"
    >
        Save
    </button>

    <!-- Discard Schedule Edits Button -->
    <button
        class="return-button"
        mat-raised-button
        (click)="cancelScheduleEdit()"
        [ngStyle]="{'display': (activeTab === 'schedule' && isEditingSchedule) ? '' : 'none' }"
        style="height: 40px;"
    >
        <mat-icon>undo</mat-icon>
        Cancel
    </button>

    <!-- Save Managed User Button -->
    <button 
        class="save-button" 
        mat-raised-button color="primary" 
        (click)="saveManagedUser()" 
        [disabled]="!managedFormDirty" 
        style="height: 40px;"
        [ngStyle]="{'display': (isAdminManagingUser && (activeTab === 'manageUsers')) ? '' : 'none' }"
    >
        Save
    </button>

    <!-- Return Button -->
    <button class="return-button" mat-raised-button (click)="manageUserReturn()" [ngStyle]="{'display': (isAdminManagingUser && (activeTab === 'manageUsers')) ? '' : 'none' }" style="height: 40px;">
        <mat-icon>undo</mat-icon>
        Return
    </button>

    <!-- Subscription Toggle, While The Schedule Form Is Open. The summary carries its own. -->
    <mat-slide-toggle
        class="subscriptionToggle"
        [ngStyle]="{'display': (activeTab === 'schedule' && isEditingSchedule) ? '' : 'none' }"
        [checked]="subscriptionFlag"
        (change)="onClickSwitch($event)"
        >Opt-in to notifications
    </mat-slide-toggle>

    <!-- Subscription Toggle For Managed Users -->
    <mat-slide-toggle
        class="subscriptionToggle"
        [ngStyle]="{'display': (isAdminManagingUser && (activeTab === 'manageUsers')) ? '' : 'none' }"
        [checked]="managedSubscriptionFlag"
        (change)="onClickSwitchManagedUserSub($event)"
        >Opt-in managed user to notifications
    </mat-slide-toggle>
</div>

<!-- Spinner -->
<div style="
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999999;
" *ngIf="showSpinner">
    <mat-spinner></mat-spinner>
</div>